import axios from 'axios';

function errorHandler(error, reject) {
  if (error.response && error.response.data) {
    reject(error.response.data);
  } else {
    reject(error);
  }
}

export default {
  list(obj) {
    obj.modeGet = 'view';
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ['page', 'limit', 'sortBy', 'sortDir', 'description', 'customer', 'is_active', 'tgl1', 'tgl2', 'modeGet'];
        let str = '';
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? '&' : '?';
            str += key + '=' + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arinvrecurring/list${str}`;
        const { data } = await axios.get(url);
        const { meta, list } = data;
        obj.total = meta.total;
        resolve(list);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  detail(key) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`/arinvrecurring/detail/${key}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  save(data) {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await axios.post('/arinvrecurring/save', data);
        resolve(resp);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  delete(recinvkey) {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await axios.post('/arinvrecurring/delete', { recinvkey });
        resolve(resp);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  toggleStatus(recinvkey, is_active) {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await axios.post('/arinvrecurring/toggle-status', { recinvkey, is_active });
        resolve(resp);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  generate(payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await axios.post('/arinvrecurring/generate', payload);
        resolve(resp);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  }
};
